import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map, take } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class UpdateDeterminationService {

  constructor(
    private http: HttpClient,
    private toastrService: ToastrService
  ) { }

  ongetSOCCode(soccode) {
    return this.http.get(`/soc/${soccode}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return null;
        }
      })
    );
  }

  getDecisionList(groupReferenceCode: string) {
    return this.http.get(`/gc/prevailingWage/${groupReferenceCode}/fetchLookupValues`)
      .pipe(map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        }
        else {
          return [];
        }
      }));
  }

  onGetWorkLocations(gcCaseId: number) {
    return this.http.get(`/gc/prevailingWage/${gcCaseId}/PwdWorkLocation`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return [];
        }
      })
    );
  }

  onPostWorkLocations(gcCaseId: number) {
    return this.http.post(`/gc/prevailingWage/${gcCaseId}/PwdWorkLocation`, {}).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return true;
        }
        else {
          return false;
        }
      })
    );
  }

  onGetUpdateDetermination(gcPwdCaseId: number) {
    return this.http.get(`/gc/prevailingWage/${gcPwdCaseId}/pwdUpdateDetermination`);
  }

  onGetPrewailingWageUploadedFile(gcPwdCaseId: number) {
    return this.http.get(`/document/gc/gcPwdeFile/${gcPwdCaseId}/category/PWDDOC/fileCategory/PWDDOC`);
  }

  onDownload(path: string, fileName: string) {
    this.http.get(path, { responseType: 'arraybuffer' })
      .pipe(take(1))
      .subscribe(data => {
        const blob = new Blob([data], { type: 'application/pdf' });
        saveAs(blob, fileName);
      });
  }

  onDelete(gcPwdCaseId: number, documentId: number) {
    return this.http.delete(`/document/gc/gcPwd/${gcPwdCaseId}/document/${documentId}`);
  }

  onPrewailingWageFileUpload(gcPwdCaseId: number, file: any) {
    return this.http.post(`/GC/PWDEFILE/${gcPwdCaseId}/document/category/PWDDOC/fileCategory/PWDDOC`, file);
  }

  onGCPWDUpdateDeterminationSave(gcPwdCaseId: number, payload: any) {
    return this.http.post(`/gc/prevailingWage/${gcPwdCaseId}/pwdUpdateDetermination`, payload);
  }

}
